const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.14});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
const mb=document.getElementById('menuBtn'),dr=document.getElementById('drawer');
mb.addEventListener('click',()=>{const o=dr.classList.toggle('open');mb.setAttribute('aria-expanded',o);mb.textContent=o?'✕':'☰'});
dr.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{dr.classList.remove('open');mb.textContent='☰';mb.setAttribute('aria-expanded',false)}));
// QUIZ
(function(){
  const QUIZ=[
    {q:"Cet été, ton envie n°1 c'est…",a:[["Bouger et me sentir plus forte","body"],["Une peau qui glow","glow"],["Manger mieux sans me priver","eat"]]},
    {q:"Le truc un peu négligé en ce moment…",a:[["Le mouvement","body"],["Ma routine peau","glow"],["Mon alimentation","eat"]]},
    {q:"Tu veux un résultat qui se voit surtout…",a:[["Dans mon énergie et mon corps","body"],["Sur ma peau","glow"],["Dans mon assiette et ma forme","eat"]]}
  ];
  const G={
    body:{name:"Body Reset",color:"#c1684a",sub:"Mouvement",txt:"Tu veux te (re)mettre en mouvement, simplement. On commence par là.",cta:"Voir le guide",href:"#guides"},
    glow:{name:"Glow All Year",color:"#dd8f9c",sub:"Peau",txt:"Une peau qui respire, toute l'année, sans routine compliquée. C'est ton guide.",cta:"Voir le guide",href:"#guides"},
    eat:{name:"Eat Stay Balanced",color:"#5fa8a3",sub:"Assiette",txt:"Bien manger sans te priver. Ton point de départ idéal.",cta:"Voir le guide",href:"#guides"},
    pack:{name:"Le pack complet",color:"#1c1613",sub:"Les 3 guides",txt:"Tu veux avancer sur tout à la fois — le pack à 39,97€ est fait pour toi.",cta:"Voir le pack — 39,97€",href:"#bundle"}
  };
  const content=document.getElementById('quizContent'),bar=document.getElementById('quizBar');
  if(!content)return;
  let step=0,score={body:0,glow:0,eat:0},firstKey=null;
  function render(){
    if(step<QUIZ.length){
      const q=QUIZ[step];
      bar.style.width=(step/QUIZ.length*100)+'%';
      content.innerHTML='<div class="quiz-q">'+q.q+'</div><div class="quiz-opts">'+q.a.map(o=>'<button type="button" class="quiz-opt" data-k="'+o[1]+'">'+o[0]+'</button>').join('')+'</div>';
      content.querySelectorAll('.quiz-opt').forEach(b=>b.addEventListener('click',()=>{if(firstKey===null)firstKey=b.dataset.k;score[b.dataset.k]++;step++;render();}));
    } else {
      bar.style.width='100%';
      const max=Math.max(score.body,score.glow,score.eat);
      const winners=Object.keys(score).filter(k=>score[k]===max);
      const key=winners.length===1?winners[0]:(winners.indexOf(firstKey)>-1?firstKey:winners[0]);
      const g=G[key];
      content.innerHTML='<div class="quiz-result"><div class="qr-eyebrow">Ton résultat</div><div class="quiz-guide" style="--gc:'+g.color+'"><div class="qg-accent"></div><div class="qg-body"><span class="qg-tag">'+g.sub+'</span><h3>'+g.name+'</h3><p>'+g.txt+'</p><div class="qg-foot"><span class="qg-price">22€</span><a href="#guides" class="btn qg-cta">Choisir ce guide</a></div></div></div><div class="qr-or">ou, encore mieux —</div><div class="quiz-pack"><div class="qp-tag">Le choix le plus malin</div><div class="qp-title">Prends-le dans le pack complet</div><div class="qp-sub">Ton guide <b>+ les 2 autres + tous les cadeaux</b>, pour seulement <b>+17,97€</b> — moins cher qu\'un seul guide de plus.</div><div class="qp-price"><span class="qp-now">39,97€</span><span class="qp-was">66€</span><span class="qp-save">Tu économises 26€</span></div><a href="#bundle" class="btn btn--solid qp-cta">Prendre le pack — 39,97€</a></div><div><button type="button" class="quiz-restart" id="quizRestart">Refaire le quiz</button></div></div>';
      document.getElementById('quizRestart').addEventListener('click',()=>{step=0;score={body:0,glow:0,eat:0};firstKey=null;render();});
    }
  }
  render();
})();
// FREEBIE — souscription Klaviyo (API client, clé publique)
(function(){
  const fb=document.getElementById('freebieBtn'),fe=document.getElementById('freebieEmail');
  if(!fb)return;
  const formEl=document.getElementById('freebieForm'),thanksEl=document.getElementById('freebieThanks');
  const KLAVIYO_COMPANY_ID='Yj2GDD',KLAVIYO_LIST_ID='XY86BZ';
  const btnLabel=fb.textContent;
  let errEl=null;
  function showError(){
    if(!errEl){
      errEl=document.createElement('p');
      errEl.className='freebie-note';
      errEl.textContent='Réessaie dans un instant.';
      formEl.appendChild(errEl);
    }
    errEl.style.display='block';
  }
  function hideError(){ if(errEl) errEl.style.display='none'; }
  function setLoading(on){
    fb.disabled=on;
    fb.textContent=on?'…':btnLabel;
  }
  fb.addEventListener('click',()=>{
    const v=(fe.value||'').trim();
    hideError();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){fe.style.borderColor='#e8889a';fe.focus();return;}
    setLoading(true);
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_COMPANY_ID,{
      method:'POST',
      headers:{'Content-Type':'application/json',revision:'2024-10-15'},
      body:JSON.stringify({
        data:{
          type:'subscription',
          attributes:{
            custom_source:'extrait-homepage',
            profile:{data:{type:'profile',attributes:{email:v}}}
          },
          relationships:{list:{data:{type:'list',id:KLAVIYO_LIST_ID}}}
        }
      })
    }).then(res=>{
      setLoading(false);
      if(res.status===202){
        formEl.style.display='none';
        thanksEl.innerHTML='<div class="freebie-check">✓</div><p><strong>C\'est bon</strong> — ton mini-guide arrive dans ta boîte mail.</p>';
        thanksEl.style.display='block';
      } else {
        showError();
      }
    }).catch(()=>{ setLoading(false); showError(); });
  });
})();
// BUY BAR
(function(){
  const bar=document.getElementById('buybar');
  if(!bar)return;
  let dismissed=false;
  const c=document.getElementById('bbClose');
  if(c)c.addEventListener('click',()=>{dismissed=true;bar.classList.remove('show');});
  const hidden=new Set();
  const zones=[document.getElementById('bundle'),document.querySelector('footer')].filter(Boolean);
  if(zones.length){
    const io2=new IntersectionObserver(es=>{es.forEach(e=>{e.isIntersecting?hidden.add(e.target):hidden.delete(e.target);});upd();},{threshold:.15});
    zones.forEach(z=>io2.observe(z));
  }
  function upd(){
    if(dismissed||hidden.size>0){bar.classList.remove('show');return;}
    const y=window.scrollY||window.pageYOffset;
    if(y>window.innerHeight*0.7){bar.classList.add('show');}else{bar.classList.remove('show');}
  }
  window.addEventListener('scroll',upd,{passive:true});
  upd();
})();